import { Box, Checkbox, FormLabel, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { useProductsContext } from 'stores/useProducts';
import { CountedProductFilters } from 'generated/graphql';
import React from 'react';
import { colors } from 'styles/theme/colors';

type Props = {
    title: keyof Omit<CountedProductFilters, '__typename'>;
    filter: {
        name: string;
        count: number;
    };
};

export default function ProductFilter({ title, filter }: Props) {
    const selectFilter = useProductsContext((store) => store.selectFilter);
    const selectedFilters = useProductsContext((store) => store.selectedFilters);

    return (
        <Box
            key={filter.name}
        >
            <FormLabel
                sx={{
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontSize: '0.75rem',
                }}
            >
                <Box>
                    <Checkbox
                        sx={{ p: 0, marginRight: 1 }}
                        size="medium"
                        onChange={() => selectFilter(title, filter.name)}
                        checked={selectedFilters[title]?.includes(filter.name) ?? false}
                        checkedIcon={(
                            <CheckIcon
                                sx={{
                                    fontSize: '1rem',
                                    border: `2.25px solid ${colors.pink2}`,
                                    borderRadius: '2px',
                                }}
                            />
                        )}
                        icon={(
                            <CheckIcon
                                sx={{
                                    fontSize: '1rem',
                                    border: '2.25px solid rgba(0,0,0,0.6)',
                                    borderRadius: '2px',
                                    color: 'transparent',
                                }}
                            />
                        )}
                    />
                    {filter.name}
                </Box>
                <Typography color={colors.gray} sx={{ fontSize: 'inherit' }}>
                    {filter.count}
                </Typography>
            </FormLabel>
        </Box>
    );
}
